import React from 'react';
import { PiButtonIconSvg } from 'components/assets/Icons/pi/pi-button';
import styles from './pi.button.module.scss';
import { useReadableEventRefresher } from '@zdrbm/zdr-react';
import { setElevioLauncherVisible } from 'utils/elevio/elevio';
import { IDrawerController } from 'features/pi/view/drawer/DrawerController';
import { Divider } from '@placer-ui/components';

type PiButtonProps = {
    drawerController: IDrawerController;
};

export const PiButton = ({ drawerController }: PiButtonProps) => {
    const [[isOpen]] = useReadableEventRefresher(drawerController.isOpen);

    return !isOpen ? (
        <>
            <Divider isVertical margin="0 8px 0 4px" dividerLength="30px" />
            <div
                role="button"
                data-testId="pi-assistant-button"
                className={styles.container}
                onClick={() => {
                    drawerController.toggleDrawer();
                    setElevioLauncherVisible(false);
                }}
            >
                <PiButtonIconSvg width={30} height={30} />
            </div>
        </>
    ) : null;
};
